module.exports = __webpack_public_path__ + "img/photo-4.b2e9eea7.jpg";